<template>
  <div class="row">
    <div class="col-md-8">
      <div class="form-group">
        Адрес
        <div class="text-muted" v-if="$editNewOrder.extra_options?.address">
          <p class="mb-0">Адрес с сайта</p>
          <p class="mb-0">{{ $editNewOrder.extra_options.address }}</p>
        </div>
        <div class="alert alert-info" v-if="!+$editNewOrder.city_id">
          для заявок с отправкой по почте, адрес должен начинаться с индекса
        </div>
        <template v-if="$platformConstants.citiesWithoutAddressValidation.includes(+$editNewOrder.city_id)">
          <input type="text" v-model="$editNewOrder.address" placeholder="Адрес доставки" class="form-control">
        </template>
        <template v-else>
          <AddressApi
            ref="APIaddress"
            :selected="$editNewOrder.address"
            :onSelect="updateAddress"
          />
        </template>
      </div>
      <div class="form-group">
        Детали (код домофона, квартира и тд)
        <input v-model="$editNewOrder.extra_options.address_details" type="text" class="form-control">
      </div>
      <div v-if="$AllCities[$editNewOrder.city_id] && $AllCities[$editNewOrder.city_id].use_metro" class="form-group">
        <div class="form-group">
          Ближайшее метро
          <v-select
            v-model="$editNewOrder.metro_station"
            @keypress.enter.native.prevent=""
            label="title"
            placeholder="Метро"
            :filterable="false"
            :options="metroList"
            @search="onSearchMetro"
          >
            <template slot="no-options">
              введите название станции..
            </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.title }}<br/>{{ option.line.title }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              {{ option.title }}
            </template>
          </v-select>
        </div>
      </div>
      <template v-if="[7].includes($editNewOrder.division_id)">
        <div class="form-group">
          Трэк номер
          <input v-model="$editNewOrder.track_number" :disabled="false" type="text"
                 class="form-control">
        </div>
        <div class="form-group">
          Почтовые расходы
          <input v-model="$editNewOrder.post_expenses" type="number" class="form-control">
        </div>
      </template>
    </div>
    <div class="col-md-4">
      <div class="form-group mb-1">
        Дата планируемой доставки
        <OrderDateSelect
          ref="selectedDate"
          :disabled="true"
          :onSelect="date => updateDeliveryDate(date)"
          :selectedDate="deliveryDate"
        />
      </div>
      <div v-if="$editNewOrder.city_id !== null"
           v-bind:class="{'mb-1 alert': true, 'alert-info': ordersInProgress <  maxOrdersQty, 'alert-danger': ordersInProgress >=  maxOrdersQty}">
        Заявок в работе: <strong>{{ ordersInProgress }}</strong>
      </div>
      <div class="form-group">
        Расчет зарплаты
        <select v-model="$editNewOrder.extra_options.salary_rate" class="form-control">
          <option value="0">по низкой ставке</option>
          <option value="1">по высокой ставке</option>
          <option value="2">по дальней ставке</option>
          <option value="999">произвольная сумма</option>
        </select>
      </div>
      <div class="form-group" v-if="$editNewOrder.extra_options.salary_rate == 999">
        Сумма зарплаты
        <input type="number" v-model="$editNewOrder.extra_options.custom_salary" class="form-control">
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          v-model="$editNewOrder.extra_options.call_day_before"
          checked
          type="checkbox"
          id="gridCheck1"
        />
        <label class="form-check-label" for="gridCheck1">
          Позвонить за день до доставки
        </label>
      </div>
      <div class="form-check" v-if="$editNewOrder.city_id != 0">
        <input
          class="form-check-input"
          v-model="$editNewOrder.extra_options.call_hour_before_delivery"
          type="checkbox"
          id="gridCheck2"
        />
        <label class="form-check-label" for="gridCheck2">
          Обязательно позвонить за час до доставки
        </label>
      </div>
      <div class="form-check" v-if="checkDeliveryBefore">
        <input
          class="form-check-input"
          v-model="$editNewOrder.extra_options.possible_early"
          type="checkbox"
          id="gridCheck3"
        />
        <label class="form-check-label" for="gridCheck3">
          Привезти раньше при наличии препаратов
        </label>
      </div>
    </div>
  </div>
</template>

<script>

import AddressApi from '@/components/address/AddressApi'
import vSelect from 'vue-select'
import moment from 'moment'
import OrderDateSelect from '@/views/reports/components/OrderDateSelect'
import AddressMap from "@/components/map/AddressMap.vue";

export default {
  props: ['checkDeliveryDate'],
  components: {
    AddressMap,
    AddressApi,
    vSelect,
    OrderDateSelect,
  },
  computed: {
    $ordersInProgress() {
      return this.$store.getters["orders/ordersInProgress"];
    },
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
    $AllDivisions() {
      return this.$store.getters["platform/divisions"];
    },
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  watch: {
    '$editNewOrder': {
      handler: function (val, oldVal) {
        this.updateOrderProgressList();
      },
      deep: true
    },
    '$ordersInProgress': {
      handler: function (val, oldVal) {
        this.updateOrderProgressList();
      },
      deep: true
    },
  },
  data() {
    return {
      metroList: [],
      deliveryDate: null,
      checkDeliveryBefore: false,
      maxOrdersQty: 10000,
      maxOrdersQtyByDivision: {
        4: 55
      },
      ordersInProgress: null,
      // minDateSelect: moment().add(1, 'days').format(),
      // maxDateSelect: moment().add(20, 'days').format(),
    }
  },
  created() {
    if (!this.$editNewOrder.extra_options) {
      this.$editNewOrder.extra_options = {}
    }
    if (!this.$editNewOrder.delivery_date) {
      this.deliveryDate = moment().add(1, 'days')
      this.$editNewOrder.delivery_date = moment(this.deliveryDate).format('YYYY-MM-DD')
    } else {
      this.deliveryDate = this.$editNewOrder.delivery_date
    }
    if (this.$editNewOrder.extra_options.salary_rate === undefined) {
      this.$editNewOrder.extra_options.salary_rate = 0
    }
    setTimeout(() => {
      this.updateOrderProgressList();
    }, 300)
  },
  methods: {
    resetData() {
      this.metroList = [];
      this.deliveryDate = moment().add(1, 'days');
      this.checkDeliveryBefore = false;
      this.$refs.APIaddress.record = null;
    },
    updateOrderProgressList() {
      // console.log('-------update order stat', this.$editNewOrder.delivery_date, this.$ordersInProgress);
      if (this.$editNewOrder.delivery_date && this.$editNewOrder.delivery_date.includes('00:00:00')) {
        this.$editNewOrder.delivery_date = moment(this.$editNewOrder.delivery_date).format('YYYY-MM-DD');
      }
      this.ordersInProgress = null;
      this.maxOrdersQty = 10000;
      let division;
      if (this.$editNewOrder.division_id) {
        division = this.$AllDivisions[this.$editNewOrder.division_id];
      } else {
        division = Object.values(this.$AllDivisions).reduce((acc, d) => {
          const preDiv = d.cities.find((c) => c.object_id === +this.$editNewOrder.city_id);
          if (preDiv) acc = d;
          return acc;
        }, {});
      }
      if (division && division.id) {
        this.ordersInProgress = +(this.$ordersInProgress[division.id]
          && this.$ordersInProgress[division.id][this.$editNewOrder.delivery_date]
          && this.$ordersInProgress[division.id][this.$editNewOrder.delivery_date].totalOrders || 0);
        if (this.maxOrdersQtyByDivision[division.id]) {
          this.maxOrdersQty = this.maxOrdersQtyByDivision[division.id]
        }
      }
    },
    checkSum(e) {
      console.log(e)
    },
    updateDeliveryDate(date) {
      const newDate = moment(date).format('YYYY-MM-DD')
      this.deliveryDate = newDate
      this.$editNewOrder.delivery_date = newDate
      this.checkDeliveryBefore = moment(newDate).diff(moment(), 'days') >= 4
      this.updateOrderProgressList();
      if (this.checkDeliveryDate) {
        this.checkDeliveryDate();
      }
    },
    updateAddress(data) {
      let address = data && data.title || null;
      if (address && +this.$editNewOrder.city_id === 2) {
        address = address.replaceAll(data.postal_code + ', ', '');
        this.$refs.APIaddress.record.title = address;
      }
      this.$editNewOrder.address = address
    },
    onSearchMetro(search, loading) {
      if (!search || search.length < 3) return
      loading(true)
      this.metroSearch(loading, search, this)
    },
    metroSearch: _.debounce((loading, search, vm) => {
      fetch(
        `/api/v1/getMetroStation?search=${encodeURIComponent(search)}`
      ).then(res => {
        res.json().then(json => (vm.metroList = json.items))
        loading(false)
      })
    }, 350),
  }
}
</script>

<style scoped>
input {
  border-radius: 0;
}
</style>
